// extracted by mini-css-extract-plugin
export default {"root":"IconAccordion_root__IUwl7"};